import {axios} from ".";
import config from '../config.json';

export const getTemplate = async (templateID) => {
  try{
    const {
      data
    } = await axios.get(`${config.base_url_api}/template/${templateID}`);
    return data;
  }catch(error)
  {
    throw new Error(error)
  }
};
export const getTemplateByName = async(name) => {
  try{
    const {
      data
    } = await axios.get(`${config.base_url_api}/template/name/${name}`);
    return data;
  }catch(error)
  {
    return null
  }
}
export const createTemplate = async (userID, template,templatename) => {
  try{
    const {
      data
    } = await axios.post(`${config.base_url_api}/template/`,{"template": template,"userid": userID, "templatename":templatename});
    return data;
  }catch(error)
  {
    throw new Error(error)
  }
}
export const updateTemplate = async (templateID, template) => {
  try{
    const {
      data
    } = await axios.put(`${config.base_url_api}/template/${templateID}`,{"template": template});
    return data;
  }catch(error)
  {
    throw new Error(error)
  }
}


